module.exports = __webpack_public_path__ + "img/icon-close-32.ceab4ccc.svg";